import { Button, ButtonProps } from '@mantine/core';
import { IconView360 } from '@tabler/icons-react';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

interface ViewJournalImpactFactorButtonProps extends ButtonProps {
  to?: string;
}

export function ViewJournalImpactFactorButton(props: ViewJournalImpactFactorButtonProps) {
  const { t } = useTranslation();
  const { to, ...buttonProps } = props;

  return (
    <>
      <Button
        {...buttonProps}
        leftSection={<IconView360 size={16} />}
        component={Link}
        to={to ?? 'impact-factor'}
      >
        {t('journals.reputation.impactFactor.button')}
      </Button>
    </>
  );
}
